import { useEffect } from 'react';
import userflow from 'userflow.js';

const useUserflow = (environment: string) => {
  const chUserDataCookie = localStorage.getItem("ch_user_data");
  const user = JSON.parse(chUserDataCookie as string);
  const userflowToken = import.meta.env.VITE_USERFLOW_TOKEN as string;

  useEffect(() => {
    const userData = user

    // Load Userflow based on environment
    userflow.init(userflowToken);

    // Identify the user
    userflow.identify(userData?._id ?? 'unauthorized', userData ? {
      name: userData.fullName,
      email: userData.email,
      signed_up_at: userData.lastSignedIn
    } : undefined);

    // Cleanup function
    return () => {
      userflow.endAll(); // End all active user flows when leaving the component
    };
  }, [environment, user]);

  return null;
};

export default useUserflow;
